let BASE_URL;

if(process.env.NODE_ENV === 'development') {
  BASE_URL = process.env.REACT_APP_DEVELOPMENT_BASE_URL;
  console.log("development Base URL:", BASE_URL);
  console.log("NODE_ENV:", process.env.NODE_ENV);
  console.log("All env vars:", process.env);
} else if(process.env.NODE_ENV === 'production') {
  BASE_URL = process.env.REACT_APP_PRODUCTION_BASE_URL;
  // console.log("production Base URL:", BASE_URL);
}

export default BASE_URL;